module.exports = __webpack_public_path__ + "static/media/nike-oranje-fatalis-6.651923b5.jpg";